export default "__VITE_ASSET__DCgq0fee__"